module.exports = __webpack_public_path__ + "static/media/Airbnb.33a2058a.png";